import { TransactionType, TransferStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsEnum } from "class-validator";
import { ForkLiftItemsDto } from "../../fork-lift-items/dto/fork-lift-items.dto";
import { ForkLiftItems } from "../../fork-lift-items/fork-lift-items.entity";
import { ForkJobPurpose } from "./fork-job-purpose.enum";
import { ForkLiftJobStatus } from "./fork-lift-job-status.enum";

export class ForkLiftJobDto {
    
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    transactionTime: Date;
    @ApiProperty({enum:Object.values(ForkLiftJobStatus)})
    @IsNotEmpty()
    @IsEnum(ForkLiftJobStatus)
    status:ForkLiftJobStatus;
    @ApiProperty({enum:Object.values(TransactionType)})
    @IsNotEmpty()
    @IsEnum(TransactionType)
    transactionType:TransactionType;
    @ApiProperty()
    currentPosition: number;
    @ApiProperty()
    targetPosition: number;
    @ApiProperty()
    realPosition: number;
    @ApiProperty()
    palletId: number;
    @ApiProperty()
    reportedId: number;
    @ApiProperty()
    totalJobCartons?: number;
    @ApiProperty()
    message: string;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    forkLiftItemsInfo: ForkLiftItemsDto[];
    @ApiProperty()
    totalIssuedQuantity?: number;
    @ApiProperty()
    totalReceivedQuantity?: number;
    @ApiProperty()
    damagedQuantity?: number;
    @ApiProperty()
    excessQuantity?: number;
    @ApiProperty()
    fromPlantId?: number;
    @ApiProperty()
    toPlantId?: number;
    @ApiProperty()
    transferStatus?: TransferStatusEnum.IN_TRANSIT;
   
    
  }